var map = {
	"./bakhro.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/bakhro.ogg",
	"./bhangera.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/bhangera.ogg",
	"./camera.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/camera.ogg",
	"./chandan.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/chandan.ogg",
	"./chandrabindu.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/chandrabindu.ogg",
	"./farsi.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/farsi.ogg",
	"./galaichha.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/galaichha.ogg",
	"./hansa.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/hansa.ogg",
	"./kakro.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/kakro.ogg",
	"./masayang.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/masayang.ogg",
	"./shichayak.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/shichayak.ogg",
	"./shishu.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/shishu.ogg",
	"./singha.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/singha.ogg",
	"./tribhuj.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/tribhuj.ogg",
	"./truck.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/truck.ogg",
	"./tukra.ogg": "./src/Containers/Play/HitTheWall/content/audios/words/level3/tukra.ogg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Containers/Play/HitTheWall/content/audios/words/level3 sync recursive ^\\.\\/.*$";